import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[preventEnterDefault]',
  standalone: true,
})
export class PreventEnterDefaultDirective {
  constructor(private el: ElementRef) {
    // el.nativeElement.bind('keydown', function (event) {
    // });
  }
  @HostListener('keydown.enter', ['$event'])
  onKeydown(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
    if (13 == e.keyCode) {
      return false;
      e.preventDefault(); // Doesn't work at all
      window.stop(); // Works in all browsers but IE...
      document.execCommand('Stop'); // Works in IE
      return false; // Don't even know why it's here. Does nothing.
    }
  }
}
